import { useState } from "react";
import { Check, ChevronsUpDown } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Command, CommandEmpty, CommandInput, CommandItem, CommandList } from "@/components/ui/command";

export const SearchSelect = ({ value, onChange, options, placeholder, searchPlaceholder, testId }) => {
  const [open, setOpen] = useState(false);
  const current = options.find((o) => o.id === value);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" data-testid={testId} role="combobox" aria-expanded={open}
          className="w-full h-12 rounded-xl border border-input bg-transparent px-4 text-sm flex items-center justify-between hover:border-primary/50 transition-colors">
          <span className={current ? "" : "text-muted-foreground"}>{current ? current.label || current.name : placeholder}</span>
          <ChevronsUpDown className="h-4 w-4 text-muted-foreground" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="p-0 w-[--radix-popover-trigger-width]" align="start">
        <Command filter={(v, s) => (v.toLowerCase().includes(s.toLowerCase()) ? 1 : 0)}>
          <CommandInput data-testid={`${testId}-search`} placeholder={searchPlaceholder} />
          <CommandList className="max-h-64">
            <CommandEmpty>No match found.</CommandEmpty>
            {options.map((o) => (
              <CommandItem key={o.id} value={`${o.name} ${o.alt || ""} ${o.id}`} data-testid={`${testId}-option-${o.id}`}
                onSelect={() => { onChange(o.id); setOpen(false); }}>
                <Check className={`h-4 w-4 mr-2 ${value === o.id ? "opacity-100" : "opacity-0"}`} />
                {o.label || o.name}
              </CommandItem>
            ))}
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
};
